import { ExternalLink } from "lucide-react";
import { RESOURCES } from "@/constants/testIds";

export const RESOURCE_CATEGORIES = [
  {
    key: "mental_health", title: "Mental Health & Emotional Support",
    items: [
      { name: "988 Suicide & Crisis Lifeline", contact: "Call or text 988", link: "https://988lifeline.org", desc: "Free, confidential crisis support, 24/7." },
      { name: "Crisis Text Line", contact: "Text HOME to 741741", link: "https://www.crisistextline.org", desc: "Free 24/7 text-based crisis support." },
      { name: "SAMHSA National Helpline", contact: "1-800-662-4357", link: "https://www.samhsa.gov/find-help/national-helpline", desc: "Free, confidential treatment referral & information, 24/7." },
      { name: "Therapy for Black Girls", contact: "therapyforblackgirls.com", link: "https://providers.therapyforblackgirls.com", desc: "Culturally responsive therapist directory, oriented especially to Black women and girls. Provider fees are set by each individual therapist and are not free." },
    ],
  },
  {
    key: "legal_aid", title: "Legal Aid & Civil Rights",
    items: [
      { name: "ACLU", contact: "aclu.org", link: "https://www.aclu.org", desc: "Know-your-rights resources and legal support network across all 50 states." },
      { name: "NAACP Legal Defense Fund", contact: "naacpldf.org", link: "https://www.naacpldf.org", desc: "Legal support for racial justice cases." },
      { name: "NAACP", contact: "naacp.org", link: "https://naacp.org/find-your-local-unit", desc: "Find your local NAACP branch for community and civil-rights support. Independent organization — not affiliated with or endorsed by BAP." },
      { name: "DOJ Civil Rights Division", contact: "1-833-591-0110", link: "https://civilrights.justice.gov", desc: "File a federal civil rights violation complaint." },
    ],
  },
  {
    key: "workplace", title: "Workplace Discrimination",
    items: [
      { name: "EEOC", contact: "1-800-669-4000 (ASL VP: 1-844-234-5122)", link: "https://www.eeoc.gov/filing-charge-discrimination", desc: "File a workplace discrimination charge with the Equal Employment Opportunity Commission." },
    ],
  },
  {
    key: "hate_crime", title: "Hate Crime Reporting",
    items: [
      { name: "FBI Hate Crimes", contact: "1-800-CALL-FBI", link: "https://hatecrimes.fbi.gov", desc: "Report a suspected hate crime to the FBI." },
      { name: "Local Police (non-emergency)", contact: "Call 911 if you are in immediate danger", link: null, desc: "File a local police report and request the report number." },
    ],
  },
];

export function ResourceCategory({ category }) {
  return (
    <div data-testid={RESOURCES.category(category.key)} className="bg-white border border-zinc-200 rounded-sm p-6">
      <h3 className="font-display font-bold text-lg text-zinc-950 mb-4">{category.title}</h3>
      <div className="space-y-4">
        {category.items.map((item) => (
          <div key={item.name} className="border-t border-zinc-100 pt-3 first:border-t-0 first:pt-0">
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold text-zinc-950 text-sm">{item.name}</p>
              {item.link && (
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-[#1E3A6E] shrink-0">
                  <ExternalLink className="h-3.5 w-3.5" />
                </a>
              )}
            </div>
            <p className="text-[#1E3A6E] text-sm font-medium">{item.contact}</p>
            <p className="text-zinc-500 text-xs leading-relaxed mt-0.5">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
